<!-- //
可视化组件的数据源绑定，数据表单
@auth xuyd
@date 2024-05-05
//-->
<template>
  <el-form @submit.native.prevent :model="datasourceProps" size="mini" :inline="false" label-position="top">
    <BlockTitle title="设置数据源"/>
    <el-form-item prop="datasourceType" label="数据源类型">
      <SelectorKeyValue v-model="datasourceProps.datasourceType"
                        :clearable="true"
                        popper-class="dv-select-pop"
                        :datasource-list="$store.getters.dictType.DATA_SOURCE_CHOOSE"/>
    </el-form-item>

    <!-- STATIC -->
    <el-row v-if="datasourceProps.datasourceType === 'STATIC'">
      <!-- String -->
      <el-form-item prop="dataSource" label="" v-if="datasourceProps.dataType === 'string'">
        <MonacoEditor v-model="dataConfig.data" :options="textDataOptions" style="height: 100px;"/>
      </el-form-item>
      <!-- 可视化编辑模式/代码编辑模式 -->
      <el-form-item prop="dataSource" label="" v-else>
        <div slot="label" class="item-label flex-row flex-valign-center">
          <span class="label">
            <span class="link" v-if="switchCodeMode" @click="switchCodeMode = !switchCodeMode">
              <i class="iconfont iconfont-Code"></i><span class="ml5">切换至可视化编辑模式</span>
            </span>
            <span class="link" v-else @click="switchCodeMode = !switchCodeMode">
              <i class="iconfont iconfont-grid"></i><span class="ml5">切换至代码编辑模式</span>
            </span>
          </span>
        </div>
        <div v-show="switchCodeMode" style="height: 300px; max-height: 300px;">
          <MonacoEditor v-model="dataConfig.data" :options="dataOptions" style="height: 300px;" @change="mergeJsonToTable"/>
        </div>
        <TableEditMode v-model="viewData"
                       :metas="viewMetas"
                       :drag-sortable="true"
                       :max-height="300"
                       v-show="!switchCodeMode"
                       @change="mergeTableToJson"/>
      </el-form-item>
    </el-row>

    <!-- API -->
    <el-row v-if="datasourceProps.datasourceType === 'API'">
      <el-form-item prop="dataSource" label="数据源">
        <SelectDatasource v-model="dataConfig.dataSource"
                          :label="dataConfig.datasourceLabel" @change="handleApiChange"/>
      </el-form-item>
      <el-form-item prop="reqParams" label="API参数">
        <MonacoEditor v-model="dataConfig.reqParams" :options="paramsOptions" style="height: 100px;"/>
      </el-form-item>

      <el-form-item prop="" label="API参数">
        <span slot="label">
          <el-button type="text" icon="el-icon-view" @click="handleApiRun">查看返回结果</el-button>
        </span>
        <MonacoEditor v-model="dataConfig.data" :options="paramsOptions" style="height: 200px;"/>
      </el-form-item>
    </el-row>
    <BlockTitle title="数据映射"/>
    <SelectDataMapping v-model="datasourceProps.dataMapping"
                       :data-prop-list="dataPropList"
                       :drag-sortable="Array.isArray(datasourceProps.dataMapping)"/>

    <BlockTitle title="数据过滤器"/>

  </el-form>
</template>

<script>

import ApiQueryParams from '@/components/Table/FormTable.vue'
import TableEditMode from './table-edit-mode.vue'
import SelectDataMapping from './select-data-mapping.vue'
import ApiDesignApi from "@/api/datasvc/apiDesign.api";

export default {
  name: 'DvPropsDatasource',
  components: {ApiQueryParams, TableEditMode, SelectDataMapping},
  dictTypes: [
    {dictType: 'DATA_SOURCE_CHOOSE', dataType: String},
  ],
  data() {
    return {
      textDataOptions: {
        autoFormat: false,
        language: '',
        languageGroup: '',
        dataType: 'string',
        fontSize: 12,
        lineNumbers: 'on',
        detectIndentation: false, // 不根据内容格式化
        tabSize: 2,
        minimap: {enabled: false}
      },
      dataOptions: {
        language: 'json',
        autoFormat: true,
        dataType: 'object',
        fontSize: 12,
        lineNumbers: 'on',
        detectIndentation: false, // 不根据内容格式化
        tabSize: 2,
        minimap: {enabled: false}
      },
      paramsOptions: {
        language: 'json',
        autoFormat: true,
        dataType: 'object',
        fontSize: 12,
        lineNumbers: 'on',
        detectIndentation: false, // 不根据内容格式化
        tabSize: 2,
        minimap: {enabled: false}
      },
      switchCodeMode: false,// 可视化（false）和代码模式切换（true）
      viewData: [], // 可视化数据模态
    }
  },
  props: {
    widgetProps: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  watch: {
    widgetProps: {
      handler: function (val) {
        console.log(`---------watch ${this.$options._componentTag} widgetProps-------->`);
        this.widgetProps = val;
        // 初始化data
        this.mergeJsonToTable();
      },
      immediate: false
    }
  },
  mounted() {
    this.mergeJsonToTable();
  },
  computed: {
    datasourceProps() {
      // console.log("=====echartsBar datasourceProps===>", JSON.stringify(this.widgetProps.datasourceProps));
      return this.widgetProps.datasourceProps;
    },
    dataConfig() {
      // console.log("=====echartsBar datasourceProps===>", this.widgetProps.datasourceProps.dataConfig['STATIC']);
      if (this.widgetProps.datasourceProps.datasourceType) {
        return this.widgetProps.datasourceProps.dataConfig[this.widgetProps.datasourceProps.datasourceType];
      }
      return {};
    },
    /**
     * 元数据
     * @returns {*[]}
     */
    viewMetas() {
      let metas = [];
      if (this.dataConfig.data && this.dataConfig.data.length > 0) {
        let rowData = this.dataConfig.data[0];
        metas = Object.keys(rowData);
      }
      return metas;
    },

    /**
     * 数据映射的下拉
     * @returns {*[]}
     */
    dataPropList() {
      let list = [];
      let rowData = {};
      if (!this.viewData) {
        return list;
      }
      if (Array.isArray(this.viewData)) {
        if (this.viewData.length > 0) {
          rowData = this.viewData[0];
        }
      } else if (this.$util.isJson(this.viewData)) {
        rowData = this.viewData;
      }
      list = Object.keys(rowData).map(key => {
        return {label: key, value: key}
      });
      return list;
    }
  },
  methods: {
    /**
     * 选择数据源事件
     *
     * @param val   value
     * @param item  对象
     */
    handleApiChange(val, item) {
      console.log("=====handleApiChange======", item);
      this.dataConfig.datasource = val;
      this.dataConfig.datasourceLabel = item.label;
      this.dataConfig.reqParams = item.req;
    },
    /**
     * 查看API返回结果
     */
    handleApiRun() {
      ApiDesignApi.runApi(this.dataConfig.datasource, this.dataConfig.reqParams).then(resp => {
        console.log(`======handleApiChange respData====>`, resp);
        this.dataConfig.data = resp.data;
        this.viewData = JSON.parse(JSON.stringify(this.dataConfig.data));
      });
    },

    // merge json to table
    mergeJsonToTable() {
      this.viewData = JSON.parse(JSON.stringify(this.dataConfig.data));
      // console.log("=====mergeJsonToTable======", this.viewData);
    },

    // merge table to json
    mergeTableToJson(viewData) {
      // console.log("=====mergeTableToJson======", viewData);
      this.dataConfig.data = JSON.parse(JSON.stringify(viewData));
    },
  }
}
</script>

<style lang="less">
@import '../../assets/css/pop.less';
</style>

<style lang="less" scoped>
@import '../../assets/css/global.less';
@import '../../assets/css/variables.less';

.link {
  color: @dv_form_link_color;
  cursor: pointer;

  .iconfont {
    font-size: 14px;
  }
}

</style>
